import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/ui/avatar.tsx");
